/**
 * The Daash connector: the Garmin MCP server people add to Claude or ChatGPT.
 *
 * The address is the server's, not this site's, and never changes with the
 * site: everyone already connected uses it.
 */
export const CONNECTOR_URL = "https://mcp.garmin.daash.run/mcp"

/** Where to send someone who wants to start using Daash. */
export const CONNECT_HREF = "/#connect"

/** A first ask brought from another page (a training plan's), for the setup steps to offer first. */
export const FIRST_ASK_KEY = "daash-first-ask"

/** The connector's own data and privacy pages, which its sign-in page links to. */
export const CONNECTOR_DATA_URL = "https://garmin.daash.run/data/"
export const CONNECTOR_PRIVACY_URL = "https://garmin.daash.run/privacy/"
export const CONNECTOR_SUPPORT_URL = "https://garmin.daash.run/support/"

export const CONNECTOR_SOURCE_URL = "https://github.com/Bartolome69/garmin-mcp"

/** Where people write for help. Received by Resend and passed on by the connector's server. */
export const SUPPORT_EMAIL = "support@daash.run"

/**
 * Where "Buy me a beer" goes: a tip page. Empty until one exists, and every
 * tip link hides itself while it is, so the site never shows a dead link.
 */
export const TIP_URL = "https://buy.stripe.com/9B628k5Unb900J46UV24000"

/** What the tip page charges, said on the button so the amount is never a surprise. Keep in step with Stripe. */
export const TIP_PRICE = "£6"
